import React from 'react';
import PropTypes from 'prop-types';
import { ComponentHeader } from '../ComponentHeader';

function ResultSection({
  hasSubtitleSeparator = true,
  titleLevel = 1,
  className,
  bodyClassName,
  imgSrc,
  imgAlt,
  title,
  titleClass,
  subTitle,
  children,
}) {
  return (
    <div className={`result-section${className ? ` ${className}` : ''}`}>
      {imgSrc && <img src={imgSrc} alt={imgAlt} title={imgAlt} />}
      <ComponentHeader
        wrapperClass="vertical-center"
        bodyClass={`text-left${bodyClassName ? ` ${bodyClassName}` : ''}`}
        titleLevel={titleLevel}
        hasSubtitleSeparator={hasSubtitleSeparator}
        title={title}
        titleClass={titleClass}
        subTitle={subTitle}
      >
        {children}
      </ComponentHeader>
    </div>
  );
}

ResultSection.propTypes = {
  className: PropTypes.string,
  title: PropTypes.node,
  subTitle: PropTypes.string,
  imgSrc: PropTypes.string,
  imgAlt: PropTypes.string,
  bodyClassName: PropTypes.string,
  hasSubtitleSeparator: PropTypes.bool,
  titleClass: PropTypes.string,
  titleLevel: PropTypes.number,
  children: PropTypes.node,
};

export { ResultSection };
